import { useEffect, useState, } from 'react';
import {
	Button,
	Card,
	CardHeader,
	Divider,
	Grid,
	List,
	ListItem,
	ListItemText,
	Typography,
} from '@mui/material';

export default function TransferListComponent(props) {
	const {
		t,
		row,
		handleClose,
		storesNames,
	} = props;
	const [left, setLeft] = useState([]);
	const [right, setRight] = useState([]);

	const customList = (title, items) => (
		<Card sx={{ width: 300, }}>
			<CardHeader
				title={<Typography sx={{ fontSize: 18, }}> {title} </Typography>}
				subheader={
					<Typography sx={{ fontSize: 14, }}>
						{items.length}
					</Typography>
				}
			/>
			<Divider />
			<List dense component="div" role="list"
				sx={{
					p: 1,
					width: '20%',
					minWidth: 300,
					height: 300,
					overflow: 'auto',
					bgcolor: 'background.paper',
				}}
			>
				{items.map((value) => {
					return (
						<ListItem
							key={value}
							role="listitem"
						>
							<ListItemText
								primary={
									<Typography sx={{ fontSize: 14, color: '#000' }}>
										{value} {storesNames[value]}
									</Typography>
								}
							/>
						</ListItem>
					);
				})}
			</List>
		</Card>
	);

	useEffect(() => {
		if (row && Object.keys(row).length > 0) {
			let newLeft = [];
			let newRight = [];
			Object.keys(row.active).forEach((key) => {
				if (row.active[key]) {
					newRight.push(key);
				} else {
					newLeft.push(key);
				}
			});
			setLeft(newLeft);
			setRight(newRight);
		}
	}, [row]);

	return (
		<Grid container direction="column" spacing={2} sx={{ px: 2, py: 1 }}>
			<Grid item>
				<Typography
					sx={{
						mt: 1,
						fontSize: 30,
						fontWeight: "40px"
					}}
				>
					{t('cws_app.tracking.See_stores')}
				</Typography>
				<Typography
					sx={{
						my: 1,
						fontSize: 18,
						fontWeight: "40px"
					}}
				>
					{row.name}
				</Typography>
			</Grid>
			<Divider variant="middle" sx={{ mx: 2, }} component="div" />
			<Grid item xs={12} container spacing={2} justifyContent="center" alignItems="center">
				<Grid item>{customList(t('cws_app.tracking.No_active_stores'), left)}</Grid>
				<Grid item>{customList(t('cws_app.tracking.Active_stores'), right)}</Grid>
			</Grid>
			<Grid item xs>
				<Grid container direction="row" justifyContent="flex-end">
					<Button
						sx={{ mt: 1, textTransform: 'none' }}
						variant="contained"
						onClick={handleClose}
						aria-label="close"
					>
						{t('cws_app.general.close')}
					</Button>
				</Grid>
			</Grid>
		</Grid>
	);
}
